import React from 'react'
import injectSheet from 'react-jss'

const NodeCrumbs = (props) => {
  const {
    classes,
    crumbs,
    history,
  } = props

  return (
    <span className={`${classes.crumbsContainer}`}>
      {crumbs.map((crumb, index) => (
        <span
          key={`crumb-${crumb.id}`}
        >
          {(index > 0) && (<span> / </span>)}
          {(crumb.path) ? (
            <span
              className="button"
              onClick={() => history.push(`/${crumb.path}`)}
              onKeyDown={() => false}
              role="button"
              tabIndex={index}
            >
              {crumb.title}
            </span>
          ) : (
            <span>
              {crumb.title}
            </span>
          )}
        </span>
      ))}
    </span>
  )
}

const styles = () => ({
  crumbsContainer: {
    '& .button': {
      cursor: 'pointer',
    },
  },
})

export default injectSheet(styles)(NodeCrumbs)



// WEBPACK FOOTER //
// ./src/modules/core/components/nodeCrumbs.jsx